import { render, staticRenderFns } from "./CreditView.vue?vue&type=template&id=688b94cf"
import script from "./CreditView.vue?vue&type=script&lang=js"
export * from "./CreditView.vue?vue&type=script&lang=js"
import style0 from "./CreditView.vue?vue&type=style&index=0&id=688b94cf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports